import { tv } from 'tailwind-variants';

export const barChartVariants = tv({
  slots: {
    base: [],
    title: ['text-primary!', 'text-xl!', 'leading-7.5', 'font-bold', 'mb-5'],
  },
});

export const barChartConfig = {
  totalHours: 24,
  fallbackFill: '#84AB3B',

  colors: {
    tickText: 'var(--color-textPrimary)',
    barLabel: '#FFFFFF',
    lineTransparent: 'transparent',
  },

  typography: {
    amPmLabel: {
      fontSize: 12,
      fontWeight: 500,
      lineHeight: '14.4px',
    },
    majorHourLabel: {
      fontSize: 14.4,
      fontWeight: 600,
    },
    barLabel: {
      fontSize: 14.4,
      fontWeight: 700,
    },
  },

  dimensions: {
    barAreaHeight: 80,
    xAxisHeight: 48,
    containerHeight: 128,
    // Extra height for two-line hour labels on narrow screens
    xAxisHeightMobile: 62,
    containerHeightMobile: 142,
  },

  margin: {
    top: 16,
    right: 16,
    left: 16,
    bottom: 30,
  },

  ticks: {
    minorStroke: 1,
    minorColor: '#aaa',
    majorStroke: 1.5,
    majorColor: '#000',
    minorHeight: 4,
    majorHeight: 10,
  },

  spacing: {
    tickLabelOffsetY: 6,
    majorTickLabelGap: 22,
    amPmTextAnchor: {
      start: 'start' as const,
      middle: 'middle' as const,
    },
  },

  // Heuristic used to decide when an hour label must wrap to two lines
  labelOverlap: {
    // Approx px width per character for the bold hour label (~0.5em)
    charWidthRatio: 0.5,
    // Approx px width per character for the uppercase AM/PM markers
    amCharWidthRatio: 0.8,
    // Minimum clear gap (px) required between two adjacent labels
    paddingPx: 6,
  },

  line: {
    dataKey: 'y',
    stroke: 'transparent',
    dot: false,
    activeDot: false,
    isAnimationActive: false,
    legendType: 'none' as const,
  },
};

export const formatHourLabel = (hour: number): string => {
  if (hour === 0 || hour === 24) return '12 a.m.';
  if (hour === 12) return '12 p.m.';
  if (hour < 12) return `${hour} a.m.`;
  return `${hour - 12} p.m.`;
};
